import React, { useState } from 'react';
import './TestimonialsSection.css';
import emmaWatsonImg from '../../assets/Testimonials/emma_watson.png';

const testimonialsData = [
  {
    id: 1,
    quote: "Implementing optimization solutions has been transformative for our business. We've seen a dramatic reduction in downtime.",
    author: "Emma Watson",
    role: "Plant Operations Director",
    image: emmaWatsonImg,
    rating: 5
  },
  {
    id: 2,
    quote: "DEXA's precision CNC machinery doubled our production capacity while maintaining tight tolerance controls across all components.",
    author: "Marcus Vance",
    role: "Chief Industrial Engineer",
    image: emmaWatsonImg,
    rating: 5
  }
];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonialsData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonialsData.length - 1 ? 0 : prev + 1));
  };

  const activeTestimonial = testimonialsData[currentIndex];

  return (
    <section className="testimonials-section" id="testimonials">
      {/* Background Vertical Grid Lines */}
      <div className="testimonials-bg-lines" aria-hidden="true">
        <div className="bg-line"></div>
        <div className="bg-line"></div>
        <div className="bg-line"></div>
        <div className="bg-line"></div>
      </div>

      <div className="testimonials-container">
        
        {/* Left Side - Headline & Partner Logos Grid */}
        <div className="testimonials-left-content">
          
          {/* Top Left Headline */}
          <h2 className="testimonials-headline">
            We've fueled success for diverse<br className="desktop-br" />
            partners, from  industries to <br className="desktop-br" />
           mid-sized  enterprises
           
          </h2>

          {/* Bottom Partner Logos Grid */}
          <div className="partner-logos-container">
            
            {/* Top Row: Signum., Dexign, Grapho, Emblem */}
            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="7" r="5" opacity="0.8" />
                <circle cx="7" cy="15" r="5" opacity="0.8" />
                <circle cx="17" cy="15" r="5" opacity="0.8" />
              </svg>
              <span>Signum.</span>
            </div>

            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <rect x="5" y="5" width="14" height="14" rx="3" transform="rotate(45 12 12)" />
              </svg>
              <span>Dexign</span>
            </div>

            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M4 12A8 8 0 0 1 20 12" />
                <path d="M7 12A5 5 0 0 1 17 12" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
              </svg>
              <span>Grapho</span>
            </div>

            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <rect x="4" y="4" width="3.5" height="16" rx="1" />
                <rect x="9.5" y="4" width="3.5" height="16" rx="1" />
                <rect x="15" y="4" width="3.5" height="16" rx="1" />
              </svg>
              <span>Emblem</span>
            </div>

            {/* Bottom Row: Logique, Signet, Imprintify */}
            <div className="partner-logo-item ">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 4H10V16H18V20H6V4Z" />
              </svg>
              <span>Logique</span>
            </div>

            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="8" />
                <circle cx="12" cy="12" r="3" fill="currentColor" />
              </svg>
              <span>Signet</span>
            </div>

            <div className="partner-logo-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <rect x="4" y="14" width="4" height="6" rx="1" />
                <rect x="10" y="10" width="4" height="10" rx="1" />
                <rect x="16" y="4" width="4" height="16" rx="1" />
              </svg>
              <span>Imprintify</span>
            </div>

          </div>

        </div>

        {/* Right Side - Combined Testimonial Card with Image */}
        <div className="testimonial-card-combined">
          
          {/* Card Left - White Content Area */}
          <div className="testimonial-white-box">
            
            {/* 5-Star Rating */}
            <div className="testimonial-rating">
              {[...Array(activeTestimonial.rating)].map((_, i) => (
                <span key={i} className="rating-star">★</span>
              ))}
            </div>

            {/* Quote Text */}
            <p className="testimonial-quote">
              "{activeTestimonial.quote}"
            </p>

            {/* Author Info & Controls */}
            <div className="testimonial-author-row">
              <h4 className="testimonial-author-name">{activeTestimonial.author}</h4>
              
              <div className="testimonial-carousel-btns">
                <button 
                  className="carousel-nav-btn" 
                  onClick={handlePrev} 
                  aria-label="Previous Testimonial"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                
                <button 
                  className="carousel-nav-btn" 
                  onClick={handleNext} 
                  aria-label="Next Testimonial"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>

          </div>

          {/* Card Right - Female Engineer Image */}
          <div className="testimonial-image-box">
            <img 
              src={activeTestimonial.image} 
              alt={activeTestimonial.author} 
              className="testimonial-person-img" 
              loading="lazy" 
            />
          </div>

        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;
